import { render } from "./MakePredictionsRugby.vue?vue&type=template&id=832f77a2&scoped=true"
import script from "./MakePredictionsRugby.vue?vue&type=script&lang=js"
export * from "./MakePredictionsRugby.vue?vue&type=script&lang=js"

import "./MakePredictionsRugby.vue?vue&type=style&index=0&id=832f77a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-832f77a2"]])

export default __exports__